import { required, requiredIf } from 'vuelidate/lib/validators'
import DatePeriodPicker from '@/components/common/dateperiodpicker/DatePeriodPicker.vue'
import Fileupload from '@/components/common/fileupload/Fileupload.vue'

const defaultEl = {
  id: null,
  contractNumber: '',
  contract_id: null,
  notifyEnding: 1,
  from_date_period_id: null,
  to_date_period_id: null,
  files: [],
  description: ''
};

export default {
  name: 'ClientContractAgreementEdit',
  props: {
    contract: Object,
    clientApiId: String
  },
  data () {
    return {
      editEl: defaultEl,
      loading: false
    }
  },
  components: {
    DatePeriodPicker,
    Fileupload
  },
  validations: {
    editEl: {
      contractNumber: { required },
      from_date_period_id: { required },
      files: {
        $each: {
          file: {
            required: requiredIf(function (el) {
              return (el && !el.filename);
            })
          }
        }
      }
    }
  },
  computed: {
    getTitle () {
      if (this.editEl.id) {
        return this.$t('menu.contractAgreement.edit');
      }
      return this.$t('menu.contractAgreement.new');
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions();
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-clients');
    }
  },
  methods: {
    show (elData) {
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      this.$v.$reset();
      this.$refs['modal-window'].show();
    },
    save () {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        this.editEl.contract_id = (this.contract ? this.contract.id : null);
        const reqData = this.ApiRequest.createFormData(this.editEl, Object.keys(defaultEl), 'contractAgreement', this);
        const self = this;
        if (reqData) {
          const path = 'client/single/' + this.clientApiId + '/contract-agreements';
          this.ApiRequest.request(path, this.ApiRequest.REQUEST_FILEUPLOAD, reqData, function (response) {
            if (response.error) {
              self.ApiRequest.displayErrorDialog(response, self);
            } else {
              self.$emit('saved', { contracts: response.data });
              self.close();
            }
            self.loading = false;
          });
        } else {
          self.ApiRequest.displayErrorDialog({ message: self.$t('general.validator.file-required') }, self);
          self.loading = false;
        }
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    },
    downloadfile (key) {
      this.editEl.files[key].loading = true;
      this.$refs.fileupload.forceUpdate(key);
      const self = this;
      this.ApiRequest.request('client/files/download/contract-agreement/' + this.editEl.files[key].id, this.ApiRequest.REQUEST_DOWNLOAD, [], function () {
        self.editEl.files[key].loading = false;
        self.$refs.fileupload.forceUpdate(key);
      });
    }
  }
}
